/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import SvgIcon from "./SvgIcon";

const Alert = ({ modifier, children }): React.FC => {
  const defaultModifier = `danger`;

  return (
    <div className={`alert alert--${modifier ? modifier : defaultModifier} mb-4`}>
      <div className="alert__content">
        <div className="grid align-items-center">
          <div className="tile-auto">
            <SvgIcon name="exclamation-triangle" className="h3" />
          </div>
          <div className="tile">{children}</div>
        </div>
      </div>
    </div>
  );
};
export default Alert;
